import styled from 'styled-components'

export const IndicatorTD = styled.td`
  text-align: right;
  white-space: nowrap;
  font-family: 'CircularStdBook', sans-serif;
  font-size: 14px;
`
export const YearTD = styled.span`
  font-weight: 500;
  font-family: 'CircularStdMedium' !important;
  font-size: 14px;
`
export const ColorBox = styled.div<{
  $bg: string
}>`
  height: 24px;
  width: 132px;
  background-color: ${(props) => props.$bg};
  cursor: pointer;
  overflow: visible;
  position: relative;
`

export const ValueRange = styled.div<{
  $bg: string
}>`
  display: flex;
  justify-content: center;
  width: 80px;
  height: 20px;
  position: relative;
  background-color: ${(props) => props.$bg};
  border-radius: 100px;
  margin-bottom: 20px;
`

export const ValueRangeValue = styled.span`
  top: 24px;
  position: absolute;
  white-space: nowrap;
  font-weight: '200';
  font-family: 'CircularStdBook', sans-serif;
  font-size: 14px;
`
